import React, { useRef, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { badgeData, logoutSuccess } from "../../store/actions";
import { Tooltip } from "react-tooltip";

import logo from "../../_assets/images/logo.png";
import SearchModule from "./SearchbyModule";
import { addRec, fetchListing } from "../../services";
import SelectDIBModal from "../Quotation/SelectDIBModal";
import MarqueeSlider from "./Marquee";
import { errorToast, userRights } from "../../_helpers/utilities";

const Topbar = () => {
  const topbarRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [opicity, setOpicity] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const { info, profilePic, menuRights } = useSelector(
    (state) => state.user
  );
  //   const filteredItems = menuRights.filter(
  //     (item) => item.ifAccessGranted && item.parentId <= 0
  //   );
  //   const sortedItems = filteredItems.sort((a, b) =>
  //     a.sorting > b.sorting ? 1 : -1
  //   );
  //   console.log(sortedItems);

  const { badgeRecords } = useSelector((state) => state.common);

  const DefaultImage = () => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      setImagePreview(process.env.REACT_APP_IMAGE_BASE_URL + profilePic);
    } else {
      setImagePreview(profilePic);
    }
  };

  React.useEffect(() => {
    DefaultImage();
  }, [profilePic]);

  // const jsonData = async () => {
  // let data = await axios.get(
  //     "https://powerliens.webmynehost.com/SEW/data.json"
  // );
  // if (data?.status === 200) {
  //     dispatch(labelValue(data?.data));
  // }
  // };
  const NotificationCount = async () => {
    let resData = await fetchListing("/Notification/GetNotificationCount");
    if (resData?.status === 200) {
      dispatch(badgeData(resData?.data));
    }
  };

  useEffect(() => {
    const intervalId = setInterval(NotificationCount, 60000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (location) {
      // jsonData();
      NotificationCount();
    }
    if (location.pathname.includes("/add")) {
      setOpicity(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    const scrollHandler = () => {
      if (window.scrollY > 70) {
        topbarRef.current.className = "scrolled";
      } else {
        topbarRef.current.className = "";
      }
    };
    if (topbarRef.current) {
      window.addEventListener("scroll", scrollHandler);
    }
    return () => window.removeEventListener("scroll", scrollHandler);
  }, [topbarRef]);

  // const redirectTo = (to) => {
  //     history.push({
  //         pathname: to,
  //         state: to.split("/").pop(),
  //     });
  // }
  const redirectTo = (to) => {
    if (to) {
      const isOnAddPage = location.pathname.includes("/add");
      const isNavigatingFromAddPage = !to.includes("/add");

      if (isOnAddPage && isNavigatingFromAddPage) {
        const shouldRedirect = window.confirm(
          "Are you sure you want to navigate away?.."
        );

        if (shouldRedirect) {
          history.push({
            pathname: to,
            state: to.split("/").pop(),
          });
        }
      } else {
        history.push({
          pathname: to,
          state: to.split("/").pop(),
        });
      }
    }
  };
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    dispatch(logoutSuccess());
    redirectTo("/login");
  };

  {/* Use Only when reset All filter*/ }
  const ReSetAllFIlterData = async () => {
    let result = await addRec("/LockData", {
      "masterEmployeeId": info?.employeeId,
      "value": "[]"
    });
    if (result?.status === 200) {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      dispatch(logoutSuccess());
      redirectTo("/login");
    } else {
      errorToast(result?.message)
    }
  };

  const SearchLink = () => {
    const [modal, setModal] = useState(false);

    useEffect(() => {
      const handleSearchKeyPress = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === "f") {
          e.preventDefault();
          setModal(true);
        }
      };
      window.addEventListener("keydown", handleSearchKeyPress);

      return () => {
        window.removeEventListener("keydown", handleSearchKeyPress);
      };
    }, []);
    return (
      <>
        {/* <a
          onClick={(e) => setModal((e) => !e)}
          style={{ color: "white" }}
          class="dropdown-item"
          href="javascript:void(0)"
        >
          <i class="fa fa-search" aria-hidden="true"></i>
        </a> */}
        {modal && <SearchModule handleClose={() => setModal(false)} />}
      </>
    );
  };

  const titleWithBadge = (title) => {
    let badgeLogo = 0;
    switch (title) {
      case "Complaint":
        badgeLogo = badgeRecords?.complaintCount;
        break;
      case "COPS":
        badgeLogo = badgeRecords?.copsCount;
        break;
      case "Flow":
        badgeLogo = badgeRecords?.driveflowCount;
        break;
      case "Approval Disassembly":
        badgeLogo = badgeRecords?.disassemblyApprovalCount;
        break;
      case "Approval PP":
        badgeLogo = badgeRecords?.ppQuotationCount;
        break;
      case "Approval SD":
        badgeLogo = badgeRecords?.sdQuotationCount;
        break;
      case "Approval FOC":
        badgeLogo = badgeRecords?.focApprovalCount;
        break;
      case "Customer Payment Type":
        badgeLogo = badgeRecords?.customerPaymentTypeApprovalCount;
        break;
      case "Customer Master Type":
        badgeLogo = badgeRecords?.customerMasterTypeApprovalCount;
        break;
      case "Approval":

        let req = badgeRecords;

        let keysToSum = [
          "ppQuotationCount",
          "sdQuotationCount",
          "customerMasterTypeApprovalCount",
          "customerPaymentTypeApprovalCount",
          "disassemblyApprovalCount",
          "focApprovalCount"
        ];

        let sum = 0;

        keysToSum.forEach(key => {
          if (req[key] > 0) {
            sum += req[key];
          }
        });
        badgeLogo = sum;
        break;


      default:
        break;
    }
    return (
      <span>
        <div class="icon-badge-container">
          {title}
          {badgeLogo > 0 && <div class="icon-badge">{badgeLogo}</div>}
        </div>
        {/* <div class="icon-badge-container">
            <i class="far fa-user icon-badge-icon"></i>
                <div class="icon-badge">6</div>
            </div> */}
      </span>
    );
  };

  const [openDIBModal, setOpenDIBModal] = useState(false);
  const openDIBModalFunc = () => {
    setOpenDIBModal(true);
  };
  const closeDIBModalFunc = () => {
    setOpenDIBModal(false);
  };

  let removeKey = ["Profile", "Links", "Email", "Stand Alone DIB"]

  let menuItem = menuRights
    .filter((item) => item.ifAccessGranted && item.parentId <= 0 && !removeKey.includes(item.moduleName))
    .sort((a, b) => (a.sorting > b.sorting ? 1 : -1));

  const subMenu = (parentID) => {
    return menuRights
      .filter((item) => item.ifAccessGranted && item.parentId === parentID)
      .sort((a, b) => (a.sorting > b.sorting ? 1 : -1));
  };
  return (
    <>
      <Tooltip
        place="left-start"
        className="tool_tip_graph"
        anchorId={"Reset_Column_Visibility_Filter"}
      />
      <Tooltip
        place="left-start"
        className="tool_tip_graph"
        anchorId={"profile"}
      />
      <Tooltip
        place="left-start"
        className="tool_tip_graph"
        anchorId={"Group_Notification"}
      />
      <Tooltip
        place="left-start"
        className="tool_tip_graph"
        anchorId={"logout"}
      />
      <header>
        <MarqueeSlider userInfo={info} />
        <nav class="navbar navbar-expand-lg navbar-light">
          <a
            class="navbar-brand"
            // onClick={() => redirectTo("/home")}
            href="javascript:void(0)"
          >
            <img src={logo} alt="logo here" width="90" />
          </a>
          {/* <div class="head_profile">
                        <img src={profile_pic} alt="" />
                    </div> */}
          <div class="head_profile">
            <div class="dropdown">
              <img
                src={imagePreview}
                class="dropdown-toggle profilePic"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                alt=""
              />
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" href="javascript:void(0)">
                    {info?.userName}
                  </a>
                </li>
                {userRights(menuRights, "Links", "Grant") && (
                  <li>
                    <a
                      class="dropdown-item"
                      onClick={() => redirectTo("/linksPath")}
                      href="javascript:void(0)"
                    >
                      Links
                    </a>
                  </li>
                )}
                {userRights(menuRights, "Stand Alone DIB", "Grant") && (
                  <li>
                    <a
                      class="dropdown-item"
                      onClick={() => openDIBModalFunc()}
                      href="javascript:void(0)"
                    >
                      DIB
                    </a>
                  </li>
                )}
                {userRights(menuRights, "Email", "Grant") && (<li>
                  <a
                    class="dropdown-item"
                    onClick={() => redirectTo("/email")}
                    href="javascript:void(0)"
                    id={"Group_Notification"}
                    data-tooltip-content={"Group Notification"}
                  >
                    Email
                  </a>
                </li>
                )}
                {/* <li>
                                    <a class="dropdown-item" href="javascript:void(0)">
                                        setting
                                    </a>
                                </li> */}
                {userRights(menuRights, "Profile", "Grant") && (
                  <li>
                    <a
                      class="dropdown-item"
                      onClick={() => redirectTo("/profile")}
                      href="javascript:void(0)"
                      id={"profile"}
                      data-tooltip-content={"User Profile"}
                    >
                      profile
                    </a>
                  </li>
                )}
                {/* Use Only when reset All filer*/}
                {(process.env.NODE_ENV === "development") &&
                  <li>
                    <a
                      class="dropdown-item"
                      onClick={() => { ReSetAllFIlterData() }}
                      href="javascript:void(0)"
                      id={"Reset_Column_Visibility_Filter"}
                      data-tooltip-content={"Reset Table Column Visibility"}
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i> Filter
                    </a>
                  </li>
                }
                <li>
                  <a
                    class="dropdown-item"
                    onClick={() => logout()}
                    href="javascript:void(0)"
                    id={"logout"}
                    data-tooltip-content={"Logout"}
                  >
                    logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div
            class="collapse navbar-collapse me-3"
            id="navbarSupportedContent"
          >
            <ul class="navbar-nav m-auto">
              {menuItem.map((obj) => {
                let subMenuItem = subMenu(obj.modulesId);
                // console.log(subMenuItem);
                return (
                  <li
                    onClick={() =>
                      obj.moduleName !== "Master" &&
                      obj.moduleName !== "Approval" &&
                      obj.moduleName !== "COPS" &&
                      obj.moduleName !== "Flow" &&
                      // && obj.title !== "Menu"
                      redirectTo(obj.link)
                    }
                    class={
                      opicity
                        ? location.pathname.split("/")[1] ==
                          obj.link.replace("/", "")
                          ? "nav-item"
                          : "nav-item opicity"
                        : "nav-item"
                    }
                  >
                    {subMenuItem && subMenuItem.length > 0 ? (
                      <li class="nav-item dropdown">
                        <a
                          href="#"
                          class={`nav-link dropdown-toggle ${location.pathname === "/cops" ? obj.modulesId === 2 ? "active" : ""
                            : location.pathname === "/flow" ? obj.modulesId === 3 ? "active" : ""
                              : location.pathname === "/cops/copsTransfer" ? obj.modulesId === 2 ? "active" : ""
                                : location.pathname === "/cops/copsDashboard" ? obj.modulesId === 2 ? "active" : ""
                                  : location.pathname === "/flow/flowTransfer" ? obj.modulesId === 3 ? "active" : ""
                                    : location.pathname === "/flow/myWorkingReport" ? obj.modulesId === 3 ? "active" : ""
                                      // newly added
                                      : location.pathname === "/ECNFlow" ? obj.modulesId === 117 ? "active" : ""
                                        : location.pathname === "/ECNFlow/addECNFlow" ? obj.modulesId === 117 ? "active" : ""
                                          : location.pathname === "/ECNFlow/ecnActionTypes" ? obj.modulesId === 117 ? "active" : ""
                                            : location.pathname === "/ECNFlow/productGroup" ? obj.modulesId === 117 ? "active" : ""
                                              : location.pathname === "/ECNReports" ? obj.modulesId === 117 ? "active" : ""
                                                : (location.pathname && obj.link && (location.pathname.split("/")[1] == obj.link.replace("/", "") ? "active" : null))}`}
                          id="navbarDropdown"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {titleWithBadge(obj.moduleName)}
                        </a>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="navbarDropdown"
                        >
                          {subMenuItem.map((item) => {
                            let subMenuItem2 = subMenu(item.modulesId);

                            return (
                              <li onClick={() => redirectTo(item.link)}>
                                <a
                                  class="dropdown-item"
                                  href="javascript:void(0)"
                                >
                                  {item?.link === "" ? item.moduleName : titleWithBadge(item.moduleName)}
                                </a>
                                {subMenuItem2 && subMenuItem.length > 0 && (
                                  <ul
                                    class="submenu dropdown-menu"
                                    aria-labelledby="navbarDropdown"
                                  >
                                    {subMenuItem2.map((sitem) => {
                                      return (
                                        <li
                                          onClick={() => redirectTo(sitem.link)}
                                        >
                                          <a
                                            class="dropdown-item"
                                            href="javascript:void(0)"
                                          >
                                            {titleWithBadge(sitem.moduleName)}
                                          </a>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                    ) : (
                      <a
                        class={
                          location.pathname == obj.link ||
                            location.pathname.split("/")[1] == obj.link.replace("/", "")
                            ? "nav-link active"
                            : "nav-link "
                        }
                        aria-current="page"
                        href="javascript:void(0)"
                      >
                        {titleWithBadge(obj.moduleName)}
                      </a>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
          {/* <button class="zip zip_icon_btn" style={{ color: "black", backgroundColor: "white", }}                 >
                        <i class="fas fa-th-large"></i>{info?.userName}
                    </button> */}
          <div>
            {/* // Search Module */}
            <SearchLink />
          </div>
        </nav>
      </header>
      <SelectDIBModal
        GetData={false}
        openDIBModal={openDIBModal}
        openDIBModalFunc={() => openDIBModalFunc()}
        closeDIBModal={() => closeDIBModalFunc()}
        ResponseData={(e, data) => console.log("e", e)}
        labelVal="DIB"
        from="Topbar"
      />
    </>
  );
};

export default Topbar;

document.addEventListener("DOMContentLoaded", function () {
  // make it as accordion for smaller screens
  if (window.innerWidth < 992) {
    // close all inner dropdowns when parent is closed
    document
      .querySelectorAll(".navbar .dropdown")
      .forEach(function (everydropdown) {
        everydropdown.addEventListener("hidden.bs.dropdown", function () {
          // after dropdown is hidden, then find all submenus
          this.querySelectorAll(".submenu").forEach(function (everysubmenu) {
            // hide every submenu as well
            everysubmenu.style.display = "none";
          });
        });
      });

    document.querySelectorAll(".dropdown-menu a").forEach(function (element) {
      element.addEventListener("click", function (e) {
        let nextEl = this.nextElementSibling;
        if (nextEl && nextEl.classList.contains("submenu")) {
          // prevent opening link if link needs to open dropdown
          e.preventDefault();
          if (nextEl.style.display == "block") {
            nextEl.style.display = "none";
          } else {
            nextEl.style.display = "block";
          }
        }
      });
    });
  }
  // end if innerWidth
});
// DOMContentLoaded  end
